import styled from "styled-components";

export const Container = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral70};
`;
